import { ChangeEvent, FormEvent, useEffect, useState } from "react";
import DcddUserForm from "./components/form/DcddUserForm";
import {
  DcddUserInput,
  DcddUserInputError,
  stateStatusType,
} from "../state/actionType";
import { connect, useSelector } from "react-redux";
import { createDcddUser } from "../state/action";
import { DcddRegistrationCategory } from "props/enum";
import DcddFormValidation from "./components/DcddFormValidation";
import { ApiError } from "components";
import filterEmptyFields from "utils/helpers/filterEmptyFields";

interface OwnProps{
  onClose?: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleCreateDcddUser: React.FC<Props> = ({
  onCreateDcddUser,
  onClose
}) => {
  const dcddCreateState = useSelector(
    (state: any) => state.dcddUser.genericDcddUserState
  );
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<DcddUserInput>({
    student_id: "",
    school_id: "",
    cid: "",
    dzongkhag_id: "",
    name: "",
    dob: "",
    category: "",
    grade_id: "",
    eccd_id: "",
    email: "",
    password: "",
    gender: "",
    mobile_no: "",
  });
  const [error, setError] = useState<DcddUserInputError>({});
  const [apiError, setApiError] = useState(null);
  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    if (name === "category") {
      setFormData({
        student_id: "",
        school_id: "",
        cid: "",
        dzongkhag_id: "",
        name: formData.name,
        dob: "",
        category: value,
        grade_id: "",
        eccd_id: "",
        email: "",
        password: "",
        gender: formData.gender,
        mobile_no: "",
      });

      setError({});
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    const errors = DcddFormValidation(formData);
    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }
    const requiredInput = {
      name: formData.name,
      gender: formData.gender,
      password: formData.password,
      dzongkhag_id: formData.dzongkhag_id,
      category: formData.category,
    };
    let conditionInputsRaw = {};
    switch (formData.category) {
      case DcddRegistrationCategory.HOME:
        conditionInputsRaw = {
          dob: formData.dob,
          cid: formData.cid,
          email: formData.email,
          mobile_no: formData.mobile_no,
        };
        break;
      case DcddRegistrationCategory.ECCD:
        conditionInputsRaw = {
          dob: formData.dob,
          cid: formData.cid,
          eccd_id: formData.eccd_id,
          student_id: formData.student_id,
          email: formData.email,
          mobile_no: formData.mobile_no,
        };
        break;
      case DcddRegistrationCategory.STUDENT:
        conditionInputsRaw = {
          dob: formData.dob,
          cid: formData.cid,
          school_id: formData.school_id,
          grade_id: formData.grade_id,
          student_id: formData.student_id,
          email: formData.email,
          mobile_no: formData.mobile_no,
        };
        break;
      case DcddRegistrationCategory.ECCD_FACILITATOR:
      case DcddRegistrationCategory.DZONGKHA_TEACHER:
        conditionInputsRaw = {
          cid: formData.cid,
          school_id: formData.school_id,
          eccd_id: formData.eccd_id,
          email: formData.email,
          mobile_no: formData.mobile_no,
        };
        break;
      default:
        break;
    }
    const conditionInputs = filterEmptyFields(conditionInputsRaw);
    const input = {
      ...requiredInput,
      ...conditionInputs,
    };
    setLoading(true);
    setSubmitted(true);
    await onCreateDcddUser(input);
    setLoading(false);
  };
  useEffect(() => {
    if (submitted) {
      if (dcddCreateState.status === stateStatusType.FAILED) {
        setApiError(dcddCreateState.error);
      } else {
        setApiError(null);
        if (onClose) onClose()
      }
    }
  }, [submitted, dcddCreateState.error, dcddCreateState.status, onClose]);
  return (
    <>
      <DcddUserForm
        header={"Create DCDD User"}
        loading={loading}
        formData={formData}
        error={error}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        onClose={onClose}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onCreateDcddUser: (signup_input: DcddUserInput) =>
    dispatch(createDcddUser(signup_input)),
});

export default connect(null, mapDispatchToProps)(HandleCreateDcddUser);
